export const SupportTicketContext = {
  mounted() {
    this.populateContext();
    this.handleViewportChange = () => this.populateContext();

    window.addEventListener('resize', this.handleViewportChange);
    window.addEventListener('orientationchange', this.handleViewportChange);
  },

  updated() {
    this.populateContext();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleViewportChange);
    window.removeEventListener('orientationchange', this.handleViewportChange);
  },

  populateContext() {
    const context = {
      current_url: window.location.href,
      route: window.location.pathname,
      browser_user_agent: navigator.userAgent || '',
      browser_language: navigator.language || '',
      browser_platform: navigator.platform || '',
      browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      environment_viewport_width: window.innerWidth,
      environment_viewport_height: window.innerHeight,
      environment_screen_width: window.screen?.width || '',
      environment_screen_height: window.screen?.height || '',
      environment_device_pixel_ratio: window.devicePixelRatio || 1,
      environment_online: navigator.onLine
    };

    Object.entries(context).forEach(([key, value]) => {
      const input = this.el.querySelector(`[data-support-ticket-context="${key}"]`);

      if (input) {
        input.value = value == null ? '' : String(value);
      }
    });
  }
};
